// extracted by mini-css-extract-plugin
export var alertIcon = "_ql-0";